export default "__VITE_ASSET__MmqANRS6__"